import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "h1 text-danger" }, " You first need to log into your account.", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "row fw-bold"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold h1" }, " Please upload following Documents ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, " (Note: only JPG, JPEG, PNG & GIF files are allowed with maximum size of 3MB) ", -1)
const _hoisted_7 = { class: "text-left container border-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-1 bg-primary" }, [
    /*#__PURE__*/_createElementVNode("td", { class: "border-1 col-3 text-center" }, "Name"),
    /*#__PURE__*/_createElementVNode("td", { class: "border-1 col-1 text-center" }, "Uploaded"),
    /*#__PURE__*/_createElementVNode("td", { class: "border-1 col-8 text-center" }, "Action")
  ])
], -1)
const _hoisted_9 = { class: "border-1" }
const _hoisted_10 = { class: "border-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "border-1" }, "    Passport", -1)
const _hoisted_12 = {
  key: 0,
  class: "border-1 text-center"
}
const _hoisted_13 = {
  key: 1,
  class: "border-1 text-center"
}
const _hoisted_14 = { class: "border-1" }
const _hoisted_15 = {
  enctype: "multipart/form-data",
  method: "post",
  id: "PassportForm"
}
const _hoisted_16 = { class: "border-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "ml-4 border-1" }, "    Passport Size Photograph", -1)
const _hoisted_18 = {
  key: 0,
  class: "border-1 text-center"
}
const _hoisted_19 = {
  key: 1,
  class: "border-1 text-center"
}
const _hoisted_20 = {
  enctype: "multipart/form-data",
  method: "post",
  id: "PhotoForm"
}
const _hoisted_21 = { class: "border-1" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, "    Visa Share Code", -1)
const _hoisted_23 = {
  key: 0,
  class: "border-1 text-center"
}
const _hoisted_24 = {
  key: 1,
  class: "border-1 text-center"
}
const _hoisted_25 = {
  enctype: "multipart/form-data",
  method: "post",
  id: "VisaForm"
}
const _hoisted_26 = { class: "border-1" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, "    SIA Licence", -1)
const _hoisted_28 = {
  key: 0,
  class: "border-1 text-center"
}
const _hoisted_29 = {
  key: 1,
  class: "border-1 text-center"
}
const _hoisted_30 = {
  enctype: "multipart/form-data",
  method: "post",
  id: "SIABadgeForm"
}
const _hoisted_31 = { class: "border-1" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, "    National Insurance Number/UTR", -1)
const _hoisted_33 = {
  key: 0,
  class: "border-1 text-center"
}
const _hoisted_34 = {
  key: 1,
  class: "border-1 text-center"
}
const _hoisted_35 = {
  enctype: "multipart/form-data",
  method: "post",
  id: "NINoDocForm"
}
const _hoisted_36 = { class: "border-1" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, "    DrivingLicence", -1)
const _hoisted_38 = {
  key: 0,
  class: "border-1 text-center"
}
const _hoisted_39 = {
  key: 1,
  class: "border-1 text-center"
}
const _hoisted_40 = {
  enctype: "multipart/form-data",
  method: "post",
  id: "DrivingLicenceForm"
}
const _hoisted_41 = { class: "border-1" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", null, "    Proof of Address 01", -1)
const _hoisted_43 = {
  key: 0,
  class: "border-1 text-center"
}
const _hoisted_44 = {
  key: 1,
  class: "border-1 text-center"
}
const _hoisted_45 = {
  enctype: "multipart/form-data",
  method: "post",
  id: "AddressDocForm"
}
const _hoisted_46 = { class: "ml-4 p-2 border-1" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", null, "    Proof of Address 02", -1)
const _hoisted_48 = {
  key: 0,
  class: "border-1 text-center"
}
const _hoisted_49 = {
  key: 1,
  class: "border-1 text-center"
}
const _hoisted_50 = {
  enctype: "multipart/form-data",
  method: "post",
  id: "AdditionalDoc1Form"
}
const _hoisted_51 = { class: "border-1" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", { class: "border-1" }, "    Supporting Document", -1)
const _hoisted_53 = {
  key: 0,
  class: "border-1 text-center"
}
const _hoisted_54 = {
  key: 1,
  class: "border-1 text-center"
}
const _hoisted_55 = { class: "border-1" }
const _hoisted_56 = {
  enctype: "multipart/form-data",
  method: "post",
  id: "AdditionalDoc2Form"
}
const _hoisted_57 = { class: "border-1" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", { class: "border-1" }, "    Supporting Document", -1)
const _hoisted_59 = {
  key: 0,
  class: "border-1 text-center"
}
const _hoisted_60 = {
  key: 1,
  class: "border-1 text-center"
}
const _hoisted_61 = { class: "border-1" }
const _hoisted_62 = {
  enctype: "multipart/form-data",
  method: "post",
  id: "AdditionalDoc3Form"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!$setup.loggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    ($setup.loggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("table", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("tbody", _hoisted_9, [
              _createElementVNode("tr", _hoisted_10, [
                _hoisted_11,
                ($setup.isDocumentUploaded('Passport.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_12, "YES"))
                  : _createCommentVNode("", true),
                (!$setup.isDocumentUploaded('Passport.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_13, "NO"))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_14, [
                  _createElementVNode("form", _hoisted_15, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.chooseDocument('Passport')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_16, [
                _hoisted_17,
                ($setup.isDocumentUploaded('Photo.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_18, "YES"))
                  : _createCommentVNode("", true),
                (!$setup.isDocumentUploaded('Photo.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_19, "NO"))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  _createElementVNode("form", _hoisted_20, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.chooseDocument('Photo')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_21, [
                _hoisted_22,
                ($setup.isDocumentUploaded('Visa.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_23, "YES"))
                  : _createCommentVNode("", true),
                (!$setup.isDocumentUploaded('Visa.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_24, "NO"))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  _createElementVNode("form", _hoisted_25, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.chooseDocument('Visa')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_26, [
                _hoisted_27,
                ($setup.isDocumentUploaded('SIABadge.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_28, "YES"))
                  : _createCommentVNode("", true),
                (!$setup.isDocumentUploaded('SIABadge.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_29, "NO"))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  _createElementVNode("form", _hoisted_30, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.chooseDocument('SIABadge')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_31, [
                _hoisted_32,
                ($setup.isDocumentUploaded('NINoDoc.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_33, "YES"))
                  : _createCommentVNode("", true),
                (!$setup.isDocumentUploaded('NINoDoc.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_34, "NO"))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  _createElementVNode("form", _hoisted_35, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.chooseDocument('NINoDoc')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_36, [
                _hoisted_37,
                ($setup.isDocumentUploaded('DrivingLicence.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_38, "YES"))
                  : _createCommentVNode("", true),
                (!$setup.isDocumentUploaded('DrivingLicence.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_39, "NO"))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  _createElementVNode("form", _hoisted_40, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.chooseDocument('DrivingLicence')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_41, [
                _hoisted_42,
                ($setup.isDocumentUploaded('AddressDoc.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_43, "YES"))
                  : _createCommentVNode("", true),
                (!$setup.isDocumentUploaded('AddressDoc.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_44, "NO"))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  _createElementVNode("form", _hoisted_45, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[6] || (_cache[6] = ($event: any) => ($setup.chooseDocument('AddressDoc')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_46, [
                _hoisted_47,
                ($setup.isDocumentUploaded('AdditionalDoc1.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_48, "YES"))
                  : _createCommentVNode("", true),
                (!$setup.isDocumentUploaded('AdditionalDoc1.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_49, "NO"))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  _createElementVNode("form", _hoisted_50, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[7] || (_cache[7] = ($event: any) => ($setup.chooseDocument('AdditionalDoc1')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_51, [
                _hoisted_52,
                ($setup.isDocumentUploaded('AdditionalDoc2.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_53, "YES"))
                  : _createCommentVNode("", true),
                (!$setup.isDocumentUploaded('AdditionalDoc2.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_54, "NO"))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_55, [
                  _createElementVNode("form", _hoisted_56, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[8] || (_cache[8] = ($event: any) => ($setup.chooseDocument('AdditionalDoc2')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_57, [
                _hoisted_58,
                ($setup.isDocumentUploaded('AdditionalDoc3.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_59, "YES"))
                  : _createCommentVNode("", true),
                (!$setup.isDocumentUploaded('AdditionalDoc3.jpg'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_60, "NO"))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_61, [
                  _createElementVNode("form", _hoisted_62, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[9] || (_cache[9] = ($event: any) => ($setup.chooseDocument('AdditionalDoc3')))
                    }, null, 32)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}